import { Component, Inject, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { FilePondModule } from 'ngx-filepond';
import { environment } from 'src/environments/environment';

import i18next from 'i18next';
import { StorageService } from 'src/app/core/storage/storage.service';
import { documentationType } from '../../model/documentation.model';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { User } from '../../model/user.model';

@Component({
  selector: 'app-drag-drop',
  templateUrl: './drag-drop.component.html',
  styleUrls: ['./drag-drop.component.scss'],
  standalone: true,
  imports: [
    I18NextModule,
    FilePondModule,
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule
  ]
})
export class DragDropComponent {
  @ViewChild('myPond') myPond: any;

  form: FormGroup;

  documento: any;

  pondOptions: any = {
    labelIdle: i18next.t('dragAndDrop'),
    server: null,
    class: 'my-filepond',
    multiple: false,
    acceptedFileTypes: ['application/pdf', 'image/jpeg'],
    maxFileSize: '2MB',
    allowDrop: true,
    allowBrowse: true,
    allowMultiple: false,
    onremovefile: () => {
      this.emptyErr = true;
    }
  };
  pondFiles = [];
  user!: User;

  documentation: any;
  disabled = true;
  addDocuError = false;
  getDocuments = true;
  url =
    environment.env === 'dev'
      ? 'https://' +
        `${environment.API_CONTEXT}/data-entry-service/v1/employee-leasing`
      : `${environment.API_CONTEXT}/data-entry-service/v1/employee-leasing`;
  //errores
  emptyErr?: boolean;
  errorMsg = '';
  genericErr = false;
  token = '';
  greenZone = false;
  nameErrorController?: boolean;
  public isSendingFile = false;

  constructor(
    private storageService: StorageService,
    public dialogRef: MatDialogRef<DragDropComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      docs: string[];
      nisTimestamp: string;
      id?: string;
      docType?: string;
    }
  ) {
    this.form = new FormGroup({
      documentType: new FormControl(data?.docType, Validators.required)
    });
    if (data?.docType) {
      this.form.get('documentType')?.disable();
    }
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.documentation = documentationType.filter((type) => {
      // Si la categoría del usuario es TMK o OMK, excluye el tipo NOMINA
      if (
        (this.user?.category === 'TMK' || this.user?.category === 'OMK') &&
        type === 'PAYROLL'
      ) {
        return false;
      }
      // Si la categoría del usuario es distinta de TMK o OMK, excluye el tipo NOMINA_CERTIFICATED
      if (
        this.user?.category !== 'TMK' &&
        this.user?.category !== 'OMK' &&
        type === 'PAYROLL_CERTIFICATED'
      ) {
        return false;
      }
      // No muestra en el select el documento que ya haya enviado
      if (!!this.data && !!this.data.docs && this.data.docs.includes(type)) {
        return false;
      }
      return true;
    });
  }

  pondHandleAddFile(event: any) {
    const fileType = event.file.fileType;
    const fileSize = event.file.fileSize;
    if (fileSize > 2000000) {
      // Si el tamaño del doc es mayor a 2MB
      this.genericErr = true;
      this.errorMsg = i18next.t('errorDocSize');
      event.remove();
    } else if (fileType !== 'application/pdf' && fileType !== 'image/jpeg') {
      this.genericErr = true;
      this.errorMsg = i18next.t('errorDocType');
      event.remove();
    } else {
      this.genericErr = false;
      this.emptyErr = false;
    }

    this.documento = {
      fileName: event.file.filename,
      file: event.file
    };
  }

  uploadFiles() {
    this.isSendingFile = true;
    let typeDoc: string;
    if (this.form.value.documentType === 'PAYROLL_CERTIFICATED') {
      typeDoc = 'PAYROLL';
    } else {
      typeDoc = this.form.value.documentType;
    }
    this.token = this.storageService?.get('token')
      ? this.storageService?.get('token').token
      : '';

    this.myPond?.pond?.setOptions({
      server: {
        process: {
          url: !!this.data.id ? `${this.url}/docs` : `${this.url}/docs/u`,
          headers: { Authorization: 'Bearer ' + this.token },
          method: !!this.data.id ? 'PUT' : 'POST',
          ondata: (formData: any) => {
            // > POST META DATA
            const formJson = !!this.data.id
              ? JSON.stringify({
                  id: this.data.id,
                  name: this.documento.fileName
                })
              : JSON.stringify({
                  tempId: this.data.nisTimestamp,
                  name: this.documento.fileName,
                  type: typeDoc
                });
            formData.append(
              'extraInfo',
              new Blob([formJson], { type: 'application/json' })
            );
            return formData;
          },
          onload: (data: any) => {
            const parsedData = JSON.parse(data);
            this.isSendingFile = true;
            this.genericErr = false;
            this.emptyErr = false;

            this.documento = {
              documentType: this.form.value.documentType,
              fileName: this.documento.fileName,
              file: this.documento.file,
              id: parsedData.idDocumento
            };

            this.dialogRef.close(this.documento);
            this.isSendingFile = false;
          },
          onerror: () => {
            this.genericErr = true;
            this.errorMsg = i18next.t('responseError');
            this.isSendingFile = false;
          },
          onremovefile: () => {
            this.emptyErr = true;
            this.isSendingFile = false;
          }
        }
      }
    });
    this.myPond?.processFile();
  }

  closeModal() {
    this.dialogRef.close();
  }
}
